import { render } from "./SwipeModalComponent.vue?vue&type=template&id=07c03991&scoped=true"
import script from "./SwipeModalComponent.vue?vue&type=script&lang=js"
export * from "./SwipeModalComponent.vue?vue&type=script&lang=js"

import "./SwipeModalComponent.vue?vue&type=style&index=0&id=07c03991&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c03991"]])

export default __exports__